import styled from 'styled-components';
import { FullWidth } from 'ui/utility/fullWidth';
import { spacing, colors } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const PageWrapper = styled(FullWidth)`
  background-color: ${colors.backgroundSecondary};
  padding-bottom: ${pxToRem(80)};
`;

export const ContentWrapper = styled.div`
  padding-left: ${spacing.layoutLRPadding};
  padding-right: ${spacing.layoutLRPadding};
`;

export const FlexContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
`;

export const InlineFlex = styled.div`
  align-items: center;
  display: inline-flex;
  gap: 10px;
`;

export const H3NoMargin = styled.h3`
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
  margin-bottom: 0;
`;

export const Layout = styled(FullWidth)`
  background-color: ${({ theme }) => theme.colors.backgroundColors.backgroundSecondary};
  display: grid;
  gap: 40px;
  grid-template-columns: 1fr;
  padding: ${({ theme }) => theme.spacing.utils.pxToRem(40)};

  @media (min-width: ${({ theme }) => theme.spacing.utils.pxToRem(720)}) {
    grid-template-columns: minmax(auto, ${({ theme }) => theme.spacing.utils.pxToRem(320)}) 1fr;
  }
`;
